import "./utils/i18n";
import "react-toastify/dist/ReactToastify.css";

import { ToastContainer, toast } from "react-toastify";
import { use, useEffect, useState } from "react";

import Body from "./components/layouts/BodyLayout";
import { DashboardProvider } from "./components/Self-Verification Tool/DashboardContext";
import { HeaderProvider } from "./utils/HeaderContext";
import { MenuProvider } from "./components/DocumentManagementSystem/DocumentMenuContext";
import { MsalProvider } from "@azure/msal-react";
import { SVTUserProvider } from "./utils/SVTUserContext";
import { SurveyProvider } from "./utils/SurveyContext";
import msalInstance from "./MsEntraConfig"; // Import the MSAL instance
import { useMsal } from "@azure/msal-react";
import ErrorBoundary from "./components/ErrorBoundry/ErrorBoundry";

msalInstance.initialize();
function App() {
    const [isAdminURL, setIsAdminURL] = useState(false);
    const { instance } = useMsal();

    const getLocation = (name) => {
        let adminScreensURL = name.pathname.includes("admin");
        if (adminScreensURL === true && name.pathname.includes("dms"))
            setIsAdminURL(false);
        else setIsAdminURL(adminScreensURL);
    };

    return (
        <MsalProvider instance={msalInstance}>
            <DashboardProvider>
                <MenuProvider>
                    <SurveyProvider>
                        <SVTUserProvider>
                            <HeaderProvider>
                                <div
                                    className={
                                        isAdminURL ? "adminMain" : "main"
                                    }
                                >
                                    <div
                                        className={
                                            isAdminURL
                                                ? "adminContainer"
                                                : "container"
                                        }
                                    >
                                        <ErrorBoundary>
                                            <Body getLocation={getLocation} />
                                        </ErrorBoundary>
                                        <ToastContainer
                                            position="top-center"
                                            theme="dark"
                                        />
                                    </div>
                                </div>
                            </HeaderProvider>
                        </SVTUserProvider>
                    </SurveyProvider>
                </MenuProvider>
            </DashboardProvider>
        </MsalProvider>
    );
}

export default App;
